import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  correction: {
    marginLeft: theme.spacing(8),
  },
}));

export default useStyles;
